const emptyThemeKeys = [
  "--input-outline",
  "--input-padding",
  "--input-border-radius",
  "--input-border-width",
  "--input-border-image",
  "--input-border-color",
  "--input-bkg-image",
  "--input-bkg-color",
  "--input-shadow",
  "--input-text-color",
  "--input-hoverfocus-padding",
  "--input-hoverfocus-border-radius",
  "--input-hoverfocus-border-width",
  "--input-hoverfocus-border-image",
  "--input-hoverfocus-border-color",
  "--input-hoverfocus-bkg-image",
  "--input-hoverfocus-bkg-color",
  "--input-hoverfocus-shadow",
  "--input-hoverfocus-text-color",
  "--input-hover-padding",
  "--input-hover-border-radius",
  "--input-hover-border-width",
  "--input-hover-border-image",
  "--input-hover-border-color",
  "--input-hover-bkg-image",
  "--input-hover-bkg-color",
  "--input-hover-shadow",
  "--input-hover-text-color",
  "--input-focus-padding",
  "--input-focus-border-radius",
  "--input-focus-border-width",
  "--input-focus-border-image",
  "--input-focus-border-color",
  "--input-focus-bkg-image",
  "--input-focus-bkg-color",
  "--input-focus-shadow",
  "--input-focus-text-color",
  "--input-invalid-padding",
  "--input-invalid-border-radius",
  "--input-invalid-border-width",
  "--input-invalid-border-image",
  "--input-invalid-border-color",
  "--input-invalid-bkg-image",
  "--input-invalid-bkg-color",
  "--input-invalid-shadow",
  "--input-invalid-text-color",
  "--input-dropdown-arrow-color",
  "--input-dropdown-arrow-hover-color",
  "--input-dropdown-option-bkg-color",
  "--input-dropdown-option-text-color",
  "--input-dropdown-option-hover-bkg-color",
  "--input-dropdown-option-hover-text-color",

  "--btn-outline",
  "--btn-primary-padding",
  "--btn-primary-border-radius",
  "--btn-primary-border-width",
  "--btn-primary-border-image",
  "--btn-primary-border-color",
  "--btn-primary-bkg-image",
  "--btn-primary-bkg-color",
  "--btn-primary-shadow",
  "--btn-primary-text-color",
  "--btn-primary-hoverfocus-padding",
  "--btn-primary-hoverfocus-border-radius",
  "--btn-primary-hoverfocus-border-width",
  "--btn-primary-hoverfocus-border-image",
  "--btn-primary-hoverfocus-border-color",
  "--btn-primary-hoverfocus-bkg-image",
  "--btn-primary-hoverfocus-bkg-color",
  "--btn-primary-hoverfocus-shadow",
  "--btn-primary-hoverfocus-text-color",
  "--btn-primary-hover-padding",
  "--btn-primary-hover-border-radius",
  "--btn-primary-hover-border-width",
  "--btn-primary-hover-border-image",
  "--btn-primary-hover-border-color",
  "--btn-primary-hover-bkg-image",
  "--btn-primary-hover-bkg-color",
  "--btn-primary-hover-shadow",
  "--btn-primary-hover-text-color",
  "--btn-primary-focus-padding",
  "--btn-primary-focus-border-radius",
  "--btn-primary-focus-border-width",
  "--btn-primary-focus-border-image",
  "--btn-primary-focus-border-color",
  "--btn-primary-focus-bkg-image",
  "--btn-primary-focus-bkg-color",
  "--btn-primary-focus-shadow",
  "--btn-primary-focus-text-color",

  "--btn-secondary-padding",
  "--btn-secondary-border-radius",
  "--btn-secondary-border-width",
  "--btn-secondary-border-image",
  "--btn-secondary-border-color",
  "--btn-secondary-bkg-image",
  "--btn-secondary-bkg-color",
  "--btn-secondary-shadow",
  "--btn-secondary-text-color",
  "--btn-secondary-hoverfocus-padding",
  "--btn-secondary-hoverfocus-border-radius",
  "--btn-secondary-hoverfocus-border-width",
  "--btn-secondary-hoverfocus-border-image",
  "--btn-secondary-hoverfocus-border-color",
  "--btn-secondary-hoverfocus-bkg-image",
  "--btn-secondary-hoverfocus-bkg-color",
  "--btn-secondary-hoverfocus-shadow",
  "--btn-secondary-hoverfocus-text-color",
  "--btn-secondary-hover-padding",
  "--btn-secondary-hover-border-radius",
  "--btn-secondary-hover-border-width",
  "--btn-secondary-hover-border-image",
  "--btn-secondary-hover-border-color",
  "--btn-secondary-hover-bkg-image",
  "--btn-secondary-hover-bkg-color",
  "--btn-secondary-hover-shadow",
  "--btn-secondary-hover-text-color",
  "--btn-secondary-focus-padding",
  "--btn-secondary-focus-border-radius",
  "--btn-secondary-focus-border-width",
  "--btn-secondary-focus-border-image",
  "--btn-secondary-focus-border-color",
  "--btn-secondary-focus-bkg-image",
  "--btn-secondary-focus-bkg-color",
  "--btn-secondary-focus-shadow",
  "--btn-secondary-focus-text-color",

  "--btn-small-padding",
  "--btn-small-border-width",
  "--btn-small-hoverfocus-padding",
  "--btn-small-hoverfocus-border-width",
  "--btn-small-hover-padding",
  "--btn-small-hover-border-width",
  "--btn-small-focus-padding",
  "--btn-small-focus-border-width",
];

const themeKeyFallbacks = {
  "--input-dropdown-arrow-hover-color": ["--input-dropdown-arrow-color"],
  "--input-hoverfocus-padding": ["--input-focus-padding", "--input-hover-padding", "--input-padding"],
  "--input-hoverfocus-border-radius": [
    "--input-focus-border-radius",
    "--input-hover-border-radius",
    "--input-border-radius",
  ],
  "--input-hoverfocus-border-width": [
    "--input-focus-border-width",
    "--input-hover-border-width",
    "--input-border-width",
  ],
  "--input-hoverfocus-border-image": [
    "--input-focus-border-image",
    "--input-hover-border-image",
    "--input-border-image",
  ],
  "--input-hoverfocus-border-color": [
    "--input-focus-border-color",
    "--input-hover-border-color",
    "--input-border-color",
  ],
  "--input-hoverfocus-bkg-image": ["--input-focus-bkg-image", "--input-hover-bkg-image", "--input-bkg-image"],
  "--input-hoverfocus-bkg-color": ["--input-focus-bkg-color", "--input-hover-bkg-color", "--input-bkg-color"],
  "--input-hoverfocus-shadow": ["--input-focus-shadow", "--input-hover-shadow", "--input-shadow"],
  "--input-hoverfocus-text-color": ["--input-focus-text-color", "--input-hover-text-color", "--input-text-color"],
  "--input-hover-padding": ["--input-padding"],
  "--input-hover-border-radius": ["--input-border-radius"],
  "--input-hover-border-width": ["--input-border-width"],
  "--input-hover-border-image": ["--input-border-image"],
  "--input-hover-border-color": ["--input-border-color"],
  "--input-hover-bkg-image": ["--input-bkg-image"],
  "--input-hover-bkg-color": ["--input-bkg-color"],
  "--input-hover-shadow": ["--input-shadow"],
  "--input-hover-text-color": ["--input-text-color"],
  "--input-focus-padding": ["--input-padding"],
  "--input-focus-border-radius": ["--input-border-radius"],
  "--input-focus-border-width": ["--input-border-width"],
  "--input-focus-border-image": ["--input-border-image"],
  "--input-focus-border-color": ["--input-border-color"],
  "--input-focus-bkg-image": ["--input-bkg-image"],
  "--input-focus-bkg-color": ["--input-bkg-color"],
  "--input-focus-shadow": ["--input-shadow"],
  "--input-focus-text-color": ["--input-text-color"],

  "--btn-primary-hoverfocus-padding": [
    "--btn-primary-focus-padding",
    "--btn-primary-hover-padding",
    "--btn-primary-padding",
  ],
  "--btn-primary-hoverfocus-border-radius": [
    "--btn-primary-focus-border-radius",
    "--btn-primary-hover-border-radius",
    "--btn-primary-border-radius",
  ],
  "--btn-primary-hoverfocus-border-width": [
    "--btn-primary-focus-border-width",
    "--btn-primary-hover-border-width",
    "--btn-primary-border-width",
  ],
  "--btn-primary-hoverfocus-border-image": [
    "--btn-primary-focus-border-image",
    "--btn-primary-hover-border-image",
    "--btn-primary-border-image",
  ],
  "--btn-primary-hoverfocus-border-color": [
    "--btn-primary-focus-border-color",
    "--btn-primary-hover-border-color",
    "--btn-primary-border-color",
  ],
  "--btn-primary-hoverfocus-bkg-image": [
    "--btn-primary-focus-bkg-image",
    "--btn-primary-hover-bkg-image",
    "--btn-primary-bkg-image",
  ],
  "--btn-primary-hoverfocus-bkg-color": [
    "--btn-primary-focus-bkg-color",
    "--btn-primary-hover-bkg-color",
    "--btn-primary-bkg-color",
  ],
  "--btn-primary-hoverfocus-shadow": [
    "--btn-primary-focus-shadow",
    "--btn-primary-hover-shadow",
    "--btn-primary-shadow",
  ],
  "--btn-primary-hoverfocus-text-color": [
    "--btn-primary-focus-text-color",
    "--btn-primary-hover-text-color",
    "--btn-primary-text-color",
  ],
  "--btn-primary-hover-padding": ["--btn-primary-padding"],
  "--btn-primary-hover-border-radius": ["--btn-primary-border-radius"],
  "--btn-primary-hover-border-width": ["--btn-primary-border-width"],
  "--btn-primary-hover-border-image": ["--btn-primary-border-image"],
  "--btn-primary-hover-border-color": ["--btn-primary-border-color"],
  "--btn-primary-hover-bkg-image": ["--btn-primary-bkg-image"],
  "--btn-primary-hover-bkg-color": ["--btn-primary-bkg-color"],
  "--btn-primary-hover-shadow": ["--btn-primary-shadow"],
  "--btn-primary-hover-text-color": ["--btn-primary-text-color"],
  "--btn-primary-focus-padding": ["--btn-primary-padding"],
  "--btn-primary-focus-border-radius": ["--btn-primary-border-radius"],
  "--btn-primary-focus-border-width": ["--btn-primary-border-width"],
  "--btn-primary-focus-border-image": ["--btn-primary-border-image"],
  "--btn-primary-focus-border-color": ["--btn-primary-border-color"],
  "--btn-primary-focus-bkg-image": ["--btn-primary-bkg-image"],
  "--btn-primary-focus-bkg-color": ["--btn-primary-bkg-color"],
  "--btn-primary-focus-shadow": ["--btn-primary-shadow"],
  "--btn-primary-focus-text-color": ["--btn-primary-text-color"],

  "--btn-secondary-hoverfocus-padding": [
    "--btn-secondary-focus-padding",
    "--btn-secondary-hover-padding",
    "--btn-secondary-padding",
  ],
  "--btn-secondary-hoverfocus-border-radius": [
    "--btn-secondary-focus-border-radius",
    "--btn-secondary-hover-border-radius",
    "--btn-secondary-border-radius",
  ],
  "--btn-secondary-hoverfocus-border-width": [
    "--btn-secondary-focus-border-width",
    "--btn-secondary-hover-border-width",
    "--btn-secondary-border-width",
  ],
  "--btn-secondary-hoverfocus-border-image": [
    "--btn-secondary-focus-border-image",
    "--btn-secondary-hover-border-image",
    "--btn-secondary-border-image",
  ],
  "--btn-secondary-hoverfocus-border-color": [
    "--btn-secondary-focus-border-color",
    "--btn-secondary-hover-border-color",
    "--btn-secondary-border-color",
  ],
  "--btn-secondary-hoverfocus-bkg-image": [
    "--btn-secondary-focus-bkg-image",
    "--btn-secondary-hover-bkg-image",
    "--btn-secondary-bkg-image",
  ],
  "--btn-secondary-hoverfocus-bkg-color": [
    "--btn-secondary-focus-bkg-color",
    "--btn-secondary-hover-bkg-color",
    "--btn-secondary-bkg-color",
  ],
  "--btn-secondary-hoverfocus-shadow": [
    "--btn-secondary-focus-shadow",
    "--btn-secondary-hover-shadow",
    "--btn-secondary-shadow",
  ],
  "--btn-secondary-hoverfocus-text-color": [
    "--btn-secondary-focus-text-color",
    "--btn-secondary-hover-text-color",
    "--btn-secondary-text-color",
  ],
  "--btn-secondary-hover-padding": ["--btn-secondary-padding"],
  "--btn-secondary-hover-border-radius": ["--btn-secondary-border-radius"],
  "--btn-secondary-hover-border-width": ["--btn-secondary-border-width"],
  "--btn-secondary-hover-border-image": ["--btn-secondary-border-image"],
  "--btn-secondary-hover-border-color": ["--btn-secondary-border-color"],
  "--btn-secondary-hover-bkg-image": ["--btn-secondary-bkg-image"],
  "--btn-secondary-hover-bkg-color": ["--btn-secondary-bkg-color"],
  "--btn-secondary-hover-shadow": ["--btn-secondary-shadow"],
  "--btn-secondary-hover-text-color": ["--btn-secondary-text-color"],
  "--btn-secondary-focus-padding": ["--btn-secondary-padding"],
  "--btn-secondary-focus-border-radius": ["--btn-secondary-border-radius"],
  "--btn-secondary-focus-border-width": ["--btn-secondary-border-width"],
  "--btn-secondary-focus-border-image": ["--btn-secondary-border-image"],
  "--btn-secondary-focus-border-color": ["--btn-secondary-border-color"],
  "--btn-secondary-focus-bkg-image": ["--btn-secondary-bkg-image"],
  "--btn-secondary-focus-bkg-color": ["--btn-secondary-bkg-color"],
  "--btn-secondary-focus-shadow": ["--btn-secondary-shadow"],
  "--btn-secondary-focus-text-color": ["--btn-secondary-text-color"],

  "--btn-small-hoverfocus-padding": ["--btn-small-focus-padding", "--btn-small-hover-padding", "--btn-small-padding"],
  "--btn-small-hoverfocus-border-width": [
    "--btn-small-focus-border-width",
    "--btn-small-hover-border-width",
    "--btn-small-border-width",
  ],
  "--btn-small-hover-padding": ["--btn-small-padding"],
  "--btn-small-hover-border-width": ["--btn-small-border-width"],
  "--btn-small-focus-padding": ["--btn-small-padding"],
  "--btn-small-focus-border-width": ["--btn-small-border-width"],
};

const defaultThemeValues = {
  "--input-padding": "10px",
  "--input-border-width": "2px",
  "--input-border-color": "transparent",
  "--btn-primary-padding": "10px 30px",
  "--btn-primary-border-width": "2px",
  "--btn-primary-border-color": "transparent",
  "--btn-secondary-padding": "10px 30px",
  "--btn-secondary-border-width": "2px",
  "--btn-secondary-border-color": "transparent",
  "--btn-small-padding": "10px",
  "--btn-small-border-width": "2px",
};

const borderlessButtonsThemeValues = {
  "--btn-primary-padding": "12px 32px",
  "--btn-primary-border-width": "0",
  "--btn-secondary-padding": "12px 32px",
  "--btn-secondary-border-width": "0",
  "--btn-small-padding": "12px",
  "--btn-small-border-width": "0",
};

const defaultFocusShadowStyle = "0 0 0 2px";

class ThemeUtils {
  constructor() {
    this.tc = require("tinycolor2");
    this.blackColor = this.tc("hsl(0, 0, 0)");
    this.whiteColor = this.tc("hsl(0, 1, 1)");

    this.themes = {
      Minimal: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues, ...borderlessButtonsThemeValues };

          const inputBorderColor = mixColor.clone().setAlpha(0.25);
          const inputHoverBorderColor = mixColor.clone().setAlpha(0.75);
          const inputHoverBkgColor = mixColor.clone().setAlpha(0.05);

          theme["--input-padding"] = "10px 10px 10px 0";
          theme["--input-border-color"] = `transparent transparent ${inputBorderColor} transparent`;
          theme["--input-bkg-color"] = "transparent";
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-border-color"] = `transparent transparent ${inputHoverBorderColor} transparent`;
          theme[
            "--input-hover-bkg-image"
          ] = `radial-gradient(circle at bottom right, ${inputHoverBkgColor}, transparent)`;
          theme["--input-focus-border-color"] = `transparent transparent ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )} transparent`;
          theme["--input-dropdown-arrow-color"] = inputBorderColor;
          theme["--input-dropdown-arrow-hover-color"] = inputHoverBorderColor;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkgColor = acc1Color;
          const buttonPrimaryHoverBkgColor = this.getShiftedLuminosityColor(
            buttonPrimaryBkgColor,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryHoverShadowColor = buttonPrimaryHoverBkgColor.clone().setAlpha(0.5);

          theme["--btn-primary-border-radius"] = "20px";
          theme["--btn-primary-bkg-color"] = buttonPrimaryBkgColor;
          theme["--btn-primary-text-color"] = buttonPrimaryBkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-primary-hover-bkg-color"] = buttonPrimaryHoverBkgColor;
          theme["--btn-primary-hover-shadow"] = `0 0 10px ${buttonPrimaryHoverShadowColor}`;
          theme["--btn-primary-hover-text-color"] = buttonPrimaryHoverBkgColor.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}`;
          theme["--btn-primary-hoverfocus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-hover-shadow"]}`;

          const buttonSecondaryBkgColor = acc2Color;
          const buttonSecondaryHoverBkgColor = this.getShiftedLuminosityColor(
            buttonSecondaryBkgColor,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryHoverShadowColor = buttonSecondaryHoverBkgColor.clone().setAlpha(0.5);

          theme["--btn-secondary-border-radius"] = theme["--btn-primary-border-radius"];
          theme["--btn-secondary-bkg-color"] = buttonSecondaryBkgColor;
          theme["--btn-secondary-text-color"] = buttonSecondaryBkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-secondary-hover-bkg-color"] = buttonSecondaryHoverBkgColor;
          theme["--btn-secondary-hover-shadow"] = `0 0 10px ${buttonSecondaryHoverShadowColor}`;
          theme["--btn-secondary-hover-text-color"] = buttonSecondaryHoverBkgColor.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}`;
          theme["--btn-secondary-hoverfocus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-hover-shadow"]}`;

          return theme;
        },
      },

      Acrylic: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues, ...borderlessButtonsThemeValues };

          const inputBorderColor = mixColor.clone().setAlpha(0.5);
          const inputBkg1Color = mixColorInv.clone().setAlpha(0.2);
          const inputBkg2Color = mixColorInv.clone().setAlpha(0.3);
          const inputShadowColor = shadowColor.clone().setAlpha(0.5);
          const inputHoverBorderColor = mixColor.clone().setAlpha(0.75);
          const inputHoverBkg1Color = mixColorInv.clone().setAlpha(0.4);
          const inputHoverBkg2Color = mixColorInv.clone().setAlpha(0.5);

          theme["--input-border-color"] = `transparent transparent ${inputBorderColor} transparent`;
          theme["--input-bkg-image"] = `linear-gradient(${inputBkg1Color} 25%, ${inputBkg2Color})`;
          theme["--input-shadow"] = `0 2px 10px ${inputShadowColor}`;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-border-color"] = `transparent transparent ${inputHoverBorderColor} transparent`;
          theme["--input-hover-bkg-image"] = `linear-gradient(${inputHoverBkg1Color} 25%, ${inputHoverBkg2Color})`;
          theme["--input-focus-border-color"] = `transparent transparent ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )} transparent`;
          theme["--input-dropdown-arrow-color"] = inputBorderColor;
          theme["--input-dropdown-arrow-hover-color"] = inputHoverBorderColor;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkgColor = acc1Color;
          const buttonPrimaryShadowColor = buttonPrimaryBkgColor.clone().setAlpha(0.25);
          const buttonPrimaryHoverBkgColor = this.getShiftedLuminosityColor(
            buttonPrimaryBkgColor,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryHoverShadowColor = buttonPrimaryHoverBkgColor.clone().setAlpha(0.25);

          theme["--btn-primary-bkg-color"] = buttonPrimaryBkgColor;
          theme["--btn-primary-shadow"] = `0 2px 10px ${buttonPrimaryShadowColor}`;
          theme["--btn-primary-text-color"] = buttonPrimaryBkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-primary-hover-bkg-color"] = buttonPrimaryHoverBkgColor;
          theme["--btn-primary-hover-shadow"] = `0 2px 10px ${buttonPrimaryHoverShadowColor}`;
          theme["--btn-primary-hover-text-color"] = buttonPrimaryHoverBkgColor.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-shadow"]}`;
          theme["--btn-primary-hoverfocus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-hover-shadow"]}`;

          const buttonSecondaryBkgColor = acc2Color;
          const buttonSecondaryShadowColor = buttonSecondaryBkgColor.clone().setAlpha(0.25);
          const buttonSecondaryHoverBkgColor = this.getShiftedLuminosityColor(
            buttonSecondaryBkgColor,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryHoverShadowColor = buttonSecondaryHoverBkgColor.clone().setAlpha(0.25);

          theme["--btn-secondary-bkg-color"] = buttonSecondaryBkgColor;
          theme["--btn-secondary-shadow"] = `0 2px 10px ${buttonSecondaryShadowColor}`;
          theme["--btn-secondary-text-color"] = buttonSecondaryBkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-secondary-hover-bkg-color"] = buttonSecondaryHoverBkgColor;
          theme["--btn-secondary-hover-shadow"] = `0 2px 10px ${buttonSecondaryHoverShadowColor}`;
          theme["--btn-secondary-hover-text-color"] = buttonSecondaryHoverBkgColor.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-shadow"]}`;
          theme["--btn-secondary-hoverfocus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-hover-shadow"]}`;

          return theme;
        },
      },

      Retro: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues, ...borderlessButtonsThemeValues };

          const inputBkgColor = this.getShiftedLuminosityColor(bkgColor, bkgColor.isLight(), -0.05);
          const inputShadowColor = this.blackColor;
          const inputHoverBkgColor = this.getShiftedLuminosityColor(bkgColor, bkgColor.isLight(), -0.1);
          const inputFocusShadow1Color = this.blackColor.clone().setAlpha(0.75);
          const inputFocusShadow2Color = this.whiteColor.clone().setAlpha(0.25);

          theme["--input-bkg-color"] = inputBkgColor;
          theme["--input-shadow"] = `2px 2px 0 ${inputShadowColor}`;
          theme["--input-text-color"] = inputBkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-border-color"] = inputHoverBkgColor;
          theme["--input-hover-bkg-color"] = inputHoverBkgColor;
          theme["--input-hover-text-color"] = inputHoverBkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--input-focus-shadow"
          ] = `inset 2px 2px 0 ${inputFocusShadow1Color}, inset -2px -2px 0 ${inputFocusShadow2Color}`;
          theme["--input-dropdown-arrow-color"] = acc1Color;
          theme["--input-dropdown-arrow-hover-color"] = acc1Color;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkgColor = acc1Color;
          const buttonPrimaryHoverBkgColor = this.getShiftedLuminosityColor(
            buttonPrimaryBkgColor,
            bkgColor.isLight(),
            0.1,
          );

          theme["--btn-primary-bkg-color"] = buttonPrimaryBkgColor;
          theme["--btn-primary-shadow"] = theme["--input-shadow"];
          theme["--btn-primary-text-color"] = buttonPrimaryBkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-primary-hover-bkg-color"] = buttonPrimaryHoverBkgColor;
          theme["--btn-primary-hover-text-color"] = buttonPrimaryHoverBkgColor.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-primary-focus-shadow"] = theme["--input-focus-shadow"];

          const buttonSecondaryBkgColor = acc2Color;
          const buttonSecondaryHoverBkgColor = this.getShiftedLuminosityColor(
            buttonSecondaryBkgColor,
            bkgColor.isLight(),
            0.1,
          );

          theme["--btn-secondary-bkg-color"] = buttonSecondaryBkgColor;
          theme["--btn-secondary-shadow"] = theme["--input-shadow"];
          theme["--btn-secondary-text-color"] = buttonSecondaryBkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-secondary-hover-bkg-color"] = buttonSecondaryHoverBkgColor;
          theme["--btn-secondary-hover-text-color"] = buttonSecondaryHoverBkgColor.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = theme["--btn-primary-focus-shadow"];

          return theme;
        },
      },

      Matte: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues, ...borderlessButtonsThemeValues };

          const spin = 15;

          const inputBorderColor = mixColorInv.clone().setAlpha(0.75);
          const inputBkg1Color = mixColorInv.clone().setAlpha(0.4);
          const inputBkg2Color = mixColorInv.clone().setAlpha(0.2);
          const inputShadowColor = shadowColor.clone().setAlpha(0.75);
          const inputHoverBorderColor = mixColorInv.clone().setAlpha(1);
          const inputHoverBkg1Color = mixColorInv.clone().setAlpha(0.6);
          const inputHoverBkg2Color = mixColorInv.clone().setAlpha(0.4);

          theme["--input-border-width"] = "2px 2px 2px 4px";
          theme["--input-border-color"] = `transparent transparent transparent ${inputBorderColor}`;
          theme["--input-bkg-image"] = `linear-gradient(to right, ${inputBkg1Color}, ${inputBkg2Color})`;
          theme["--input-shadow"] = `0 2px 5px ${inputShadowColor}`;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-border-color"] = `transparent transparent transparent ${inputHoverBorderColor}`;
          theme[
            "--input-hover-bkg-image"
          ] = `linear-gradient(to right, ${inputHoverBkg1Color}, ${inputHoverBkg2Color})`;
          theme["--input-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-focus-border-color"] = `transparent transparent transparent ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}`;
          theme["--input-dropdown-arrow-color"] = acc1Color;
          theme["--input-dropdown-arrow-hover-color"] = acc1Color;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkg1Color = acc1Color;
          const buttonPrimaryBkg2Color = acc1Color.clone().spin(spin);
          const buttonPrimaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );

          theme[
            "--btn-primary-bkg-image"
          ] = `linear-gradient(to right, ${buttonPrimaryBkg1Color}, ${buttonPrimaryBkg2Color})`;
          theme["--btn-primary-shadow"] = theme["--input-shadow"];
          theme["--btn-primary-text-color"] = buttonPrimaryBkg1Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-primary-hover-bkg-image"
          ] = `linear-gradient(to right, ${buttonPrimaryHoverBkg1Color}, ${buttonPrimaryHoverBkg2Color})`;
          theme["--btn-primary-hover-text-color"] = buttonPrimaryHoverBkg1Color.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-shadow"]}`;

          const buttonSecondaryBkg1Color = acc2Color;
          const buttonSecondaryBkg2Color = acc2Color.clone().spin(spin);
          const buttonSecondaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );

          theme[
            "--btn-secondary-bkg-image"
          ] = `linear-gradient(to right, ${buttonSecondaryBkg1Color}, ${buttonSecondaryBkg2Color})`;
          theme["--btn-secondary-shadow"] = theme["--btn-primary-shadow"];
          theme["--btn-secondary-text-color"] = buttonSecondaryBkg1Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-secondary-hover-bkg-image"
          ] = `linear-gradient(to right, ${buttonSecondaryHoverBkg1Color}, ${buttonSecondaryHoverBkg2Color})`;
          theme["--btn-secondary-hover-text-color"] = buttonSecondaryHoverBkg1Color.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-shadow"]}`;

          return theme;
        },
      },

      Shaded: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues, ...borderlessButtonsThemeValues };

          const spin = 15;

          const inputBkg1Color = mixColorInv.clone().setAlpha(0.6);
          const inputBkg2Color = mixColorInv.clone().setAlpha(0.4);
          const inputShadowColor = shadowColor.clone().setAlpha(0.5);
          const inputHoverBkg1Color = mixColorInv.clone().setAlpha(0.8);
          const inputHoverBkg2Color = mixColorInv.clone().setAlpha(0.6);

          theme["--input-padding"] = "11px";
          theme["--input-border-width"] = "1px";
          theme["--input-border-radius"] = "5px";
          theme["--input-border-color"] = inputBkg1Color;
          theme["--input-bkg-image"] = `linear-gradient(${inputBkg1Color}, ${inputBkg2Color})`;
          theme["--input-shadow"] = `0 2px 15px ${inputShadowColor}`;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-border-color"] = inputHoverBkg1Color;
          theme["--input-hover-bkg-image"] = `linear-gradient(${inputHoverBkg1Color}, ${inputHoverBkg2Color})`;
          theme["--input-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--input-shadow"]}`;
          theme["--input-dropdown-arrow-color"] = acc1Color;
          theme["--input-dropdown-arrow-hover-color"] = acc1Color;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkg1Color = acc1Color;
          const buttonPrimaryBkg2Color = acc1Color.clone().spin(spin);
          const buttonPrimaryShadowColor = buttonPrimaryBkg1Color.clone().setAlpha(0.5);
          const buttonPrimaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryHoverShadowColor = buttonPrimaryHoverBkg1Color.clone().setAlpha(0.5);

          theme["--btn-primary-border-radius"] = "5px";
          theme["--btn-primary-bkg-image"] = `linear-gradient(${buttonPrimaryBkg1Color}, ${buttonPrimaryBkg2Color})`;
          theme["--btn-primary-shadow"] = `0 2px 15px ${buttonPrimaryShadowColor}`;
          theme["--btn-primary-text-color"] = buttonPrimaryBkg1Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-primary-hover-bkg-image"
          ] = `linear-gradient(${buttonPrimaryHoverBkg1Color}, ${buttonPrimaryHoverBkg2Color})`;
          theme["--btn-primary-hover-shadow"] = `0 2px 15px ${buttonPrimaryHoverShadowColor}`;
          theme["--btn-primary-hover-text-color"] = buttonPrimaryHoverBkg1Color.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-shadow"]}`;
          theme["--btn-primary-hoverfocus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-hover-shadow"]}`;

          const buttonSecondaryBkg1Color = acc2Color;
          const buttonSecondaryBkg2Color = acc2Color.clone().spin(spin);
          const buttonSecondaryShadowColor = buttonSecondaryBkg1Color.clone().setAlpha(0.5);
          const buttonSecondaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryHoverShadowColor = buttonSecondaryHoverBkg1Color.clone().setAlpha(0.5);

          theme["--btn-secondary-border-radius"] = theme["--btn-primary-border-radius"];
          theme[
            "--btn-secondary-bkg-image"
          ] = `linear-gradient(${buttonSecondaryBkg1Color}, ${buttonSecondaryBkg2Color})`;
          theme["--btn-secondary-shadow"] = `0 2px 15px ${buttonSecondaryShadowColor}`;
          theme["--btn-secondary-text-color"] = buttonSecondaryBkg1Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-secondary-hover-bkg-image"
          ] = `linear-gradient(${buttonSecondaryHoverBkg1Color}, ${buttonSecondaryHoverBkg2Color})`;
          theme["--btn-secondary-hover-shadow"] = `0 2px 15px ${buttonSecondaryHoverShadowColor}`;
          theme["--btn-secondary-hover-text-color"] = buttonSecondaryHoverBkg1Color.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-shadow"]}`;
          theme["--btn-secondary-hoverfocus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-hover-shadow"]}`;

          return theme;
        },
      },

      Beveled: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues };

          const inputBorderColor = this.blackColor.clone().setAlpha(0.25);
          const inputBkg1Color = mixColorInv.clone().setAlpha(0.5);
          const inputBkg2Color = mixColorInv.clone().setAlpha(0.25);
          const inputShadowColor = mixColorInv;
          const inputHoverBkg1Color = mixColorInv.clone().setAlpha(0.75);
          const inputHoverBkg2Color = mixColorInv.clone().setAlpha(0.5);

          theme["--input-border-radius"] = "5px";
          theme["--input-border-color"] = inputBorderColor;
          theme["--input-bkg-image"] = `linear-gradient(${inputBkg1Color}, ${inputBkg2Color})`;
          theme["--input-shadow"] = `inset 0 1px 10px ${inputShadowColor}`;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-bkg-image"] = `linear-gradient(${inputHoverBkg1Color}, ${inputHoverBkg2Color})`;
          theme["--input-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--input-shadow"]}`;
          theme["--input-dropdown-arrow-color"] = acc1Color;
          theme["--input-dropdown-arrow-hover-color"] = acc1Color;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkg1Color = this.tc.mix(acc1Color, this.whiteColor, 35);
          const buttonPrimaryBkg2Color = this.tc.mix(acc1Color, this.blackColor, 35);
          const buttonPrimaryShadowColor = shadowColor.clone().setAlpha(0.75);
          const buttonPrimaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );

          theme["--btn-primary-border-radius"] = "5px";
          theme["--btn-primary-border-color"] = this.blackColor;
          theme["--btn-primary-bkg-image"] = `linear-gradient(${buttonPrimaryBkg1Color}, ${buttonPrimaryBkg2Color})`;
          theme["--btn-primary-shadow"] = `0 1px 10px ${buttonPrimaryShadowColor}`;
          theme["--btn-primary-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-primary-hover-bkg-image"
          ] = `linear-gradient(${buttonPrimaryHoverBkg1Color}, ${buttonPrimaryHoverBkg2Color})`;
          theme["--btn-primary-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-shadow"]}`;

          const buttonSecondaryBkg1Color = this.tc.mix(acc2Color, this.whiteColor, 35);
          const buttonSecondaryBkg2Color = this.tc.mix(acc2Color, this.blackColor, 35);
          const buttonSecondaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );

          theme["--btn-secondary-padding"] = theme["--btn-primary-padding"];
          theme["--btn-secondary-border-width"] = theme["--btn-primary-border-width"];
          theme["--btn-secondary-border-radius"] = theme["--btn-primary-border-radius"];
          theme["--btn-secondary-border-color"] = theme["--btn-primary-border-color"];
          theme[
            "--btn-secondary-bkg-image"
          ] = `linear-gradient(${buttonSecondaryBkg1Color}, ${buttonSecondaryBkg2Color})`;
          theme["--btn-secondary-shadow"] = theme["--btn-primary-shadow"];
          theme["--btn-secondary-text-color"] = acc2Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-secondary-hover-bkg-image"
          ] = `linear-gradient(${buttonSecondaryHoverBkg1Color}, ${buttonSecondaryHoverBkg2Color})`;
          theme["--btn-secondary-hover-text-color"] = acc2Color.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-shadow"]}`;

          return theme;
        },
      },

      Glossy: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues };

          const inputBorderColor = this.blackColor.clone().setAlpha(0.5);
          const inputBkg1Color = mixColorInv.clone().setAlpha(0.5);
          const inputBkg2Color = mixColorInv.clone().setAlpha(0.25);
          const inputShadow1Color = mixColorInv.clone().setAlpha(0.5);
          const inputShadow2Color = this.whiteColor.clone().setAlpha(0.25);
          const inputHoverBkg1Color = mixColorInv.clone().setAlpha(0.75);
          const inputHoverBkg2Color = mixColorInv.clone().setAlpha(0.5);

          theme["--input-border-radius"] = "5px";
          theme["--input-border-color"] = inputBorderColor;
          theme["--input-bkg-image"] = `linear-gradient(${inputBkg1Color}, ${inputBkg2Color})`;
          theme["--input-shadow"] = `inset 0 1px 5px ${inputShadow1Color}, 0 1px 5px ${inputShadow2Color}`;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-bkg-image"] = `linear-gradient(${inputHoverBkg1Color}, ${inputHoverBkg2Color})`;
          theme["--input-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--input-shadow"]}`;
          theme["--input-dropdown-arrow-color"] = acc1Color;
          theme["--input-dropdown-arrow-hover-color"] = acc1Color;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkg1Color = this.tc.mix(acc1Color, this.whiteColor, 25);
          const buttonPrimaryBkg2Color = this.tc.mix(acc1Color, this.blackColor, 25);
          const buttonPrimaryShadow1Color = this.whiteColor.clone().setAlpha(0.25);
          const buttonPrimaryShadow2Color = shadowColor.clone().setAlpha(0.75);
          const buttonPrimaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );

          theme["--btn-primary-border-radius"] = "5px";
          theme["--btn-primary-border-color"] = this.blackColor;
          theme["--btn-primary-bkg-image"] = `linear-gradient(${buttonPrimaryBkg1Color}, ${buttonPrimaryBkg2Color})`;
          theme[
            "--btn-primary-shadow"
          ] = `inset 0 20px 2px ${buttonPrimaryShadow1Color}, 0 1px 10px ${buttonPrimaryShadow2Color}`;
          theme["--btn-primary-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-primary-hover-bkg-image"
          ] = `linear-gradient(${buttonPrimaryHoverBkg1Color}, ${buttonPrimaryHoverBkg2Color})`;
          theme["--btn-primary-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-shadow"]}`;

          const buttonSecondaryBkg1Color = this.tc.mix(acc2Color, this.whiteColor, 25);
          const buttonSecondaryBkg2Color = this.tc.mix(acc2Color, this.blackColor, 25);
          const buttonSecondaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );

          theme["--btn-secondary-padding"] = theme["--btn-primary-padding"];
          theme["--btn-secondary-border-width"] = theme["--btn-primary-border-width"];
          theme["--btn-secondary-border-radius"] = theme["--btn-primary-border-radius"];
          theme["--btn-secondary-border-color"] = theme["--btn-primary-border-color"];
          theme[
            "--btn-secondary-bkg-image"
          ] = `linear-gradient(${buttonSecondaryBkg1Color}, ${buttonSecondaryBkg2Color})`;
          theme["--btn-secondary-shadow"] = theme["--btn-primary-shadow"];
          theme["--btn-secondary-text-color"] = acc2Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-secondary-hover-bkg-image"
          ] = `linear-gradient(${buttonSecondaryHoverBkg1Color}, ${buttonSecondaryHoverBkg2Color})`;
          theme["--btn-secondary-hover-text-color"] = acc2Color.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-shadow"]}`;

          return theme;
        },
      },

      Gemstone: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues };

          const alAcc1Color = this.getAverageLuminosityColor(acc1Color);
          const alAcc2Color = this.getAverageLuminosityColor(acc2Color);

          const inputBorderColor = shadowColor.clone().setAlpha(0.5);
          const inputBkg1Color = mixColorInv.clone().setAlpha(0);
          const inputBkg2Color = mixColorInv.clone().setAlpha(0.75);
          const inputBkg3Color = mixColor.clone().setAlpha(0.5);
          const inputBkg4Color = mixColor.clone().setAlpha(0.25);
          const inputShadowColor = shadowColor.clone().setAlpha(0.75);
          const inputHoverBkg1Color = mixColorInv.clone().setAlpha(0.25);
          const inputHoverBkg2Color = mixColorInv.clone().setAlpha(1);
          const inputHoverBkg3Color = inputBkg3Color;
          const inputHoverBkg4Color = inputBkg4Color;

          theme["--input-border-radius"] = "10px";
          theme["--input-border-color"] = inputBorderColor;
          theme[
            "--input-bkg-image"
          ] = `linear-gradient(${inputBkg3Color}, transparent 10%, transparent 90%, ${inputBkg3Color}), linear-gradient(${inputBkg4Color}, transparent 25%, transparent 75%, ${inputBkg4Color}), linear-gradient(${inputBkg1Color}, ${inputBkg2Color})`;
          theme["--input-shadow"] = `0 1px 10px ${inputShadowColor}`;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--input-hover-bkg-image"
          ] = `linear-gradient(${inputHoverBkg3Color}, transparent 10%, transparent 90%, ${inputHoverBkg3Color}), linear-gradient(${inputHoverBkg4Color}, transparent 25%, transparent 75%, ${inputHoverBkg4Color}), linear-gradient(${inputHoverBkg1Color}, ${inputHoverBkg2Color})`;
          theme["--input-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--input-shadow"]}`;
          theme["--input-dropdown-arrow-color"] = acc1Color;
          theme["--input-dropdown-arrow-hover-color"] = acc1Color;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkg1Color = this.tc.mix(bkgColor, this.blackColor, 100);
          const buttonPrimaryBkg2Color = this.tc.mix(alAcc1Color, this.whiteColor, 75);
          const buttonPrimaryBkg3Color = alAcc1Color.clone().setAlpha(0.25);
          const buttonPrimaryBkg4Color = alAcc1Color.clone().setAlpha(0.5);
          const buttonPrimaryHoverBkg1Color = this.tc.mix(alAcc1Color, this.blackColor, 75);
          const buttonPrimaryHoverBkg2Color = buttonPrimaryBkg2Color;
          const buttonPrimaryHoverBkg3Color = buttonPrimaryBkg3Color;
          const buttonPrimaryHoverBkg4Color = buttonPrimaryBkg4Color;

          theme["--btn-primary-border-radius"] = theme["--input-border-radius"];
          theme["--btn-primary-border-color"] = buttonPrimaryBkg1Color;
          theme[
            "--btn-primary-bkg-image"
          ] = `radial-gradient(50% 50% at left, ${buttonPrimaryBkg3Color}, transparent), radial-gradient(50% 50% at right, ${buttonPrimaryBkg3Color}, transparent), radial-gradient(100% 50% at top, ${buttonPrimaryBkg2Color}, ${buttonPrimaryBkg4Color}, transparent), radial-gradient(100% 50% at bottom, ${buttonPrimaryBkg2Color}, ${buttonPrimaryBkg4Color}, transparent), linear-gradient(${buttonPrimaryBkg1Color}, ${buttonPrimaryBkg1Color})`;
          theme["--btn-primary-shadow"] = theme["--input-shadow"];
          theme["--btn-primary-text-color"] = this.whiteColor;
          theme["--btn-primary-hover-border-color"] = buttonPrimaryHoverBkg1Color;
          theme[
            "--btn-primary-hover-bkg-image"
          ] = `radial-gradient(50% 50% at left, ${buttonPrimaryHoverBkg3Color}, transparent), radial-gradient(50% 50% at right, ${buttonPrimaryHoverBkg3Color}, transparent), radial-gradient(100% 50% at top, ${buttonPrimaryHoverBkg2Color}, ${buttonPrimaryHoverBkg4Color}, transparent), radial-gradient(100% 50% at bottom, ${buttonPrimaryHoverBkg2Color}, ${buttonPrimaryHoverBkg4Color}, transparent), linear-gradient(${buttonPrimaryHoverBkg1Color}, ${buttonPrimaryHoverBkg1Color})`;
          theme["--btn-primary-hover-text-color"] = this.whiteColor;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-shadow"]}`;

          const buttonSecondaryBkg1Color = this.tc.mix(bkgColor, this.blackColor, 100);
          const buttonSecondaryBkg2Color = this.tc.mix(alAcc2Color, this.whiteColor, 75);
          const buttonSecondaryBkg3Color = alAcc2Color.clone().setAlpha(0.25);
          const buttonSecondaryBkg4Color = alAcc2Color.clone().setAlpha(0.5);
          const buttonSecondaryHoverBkg1Color = this.tc.mix(alAcc2Color, this.blackColor, 75);
          const buttonSecondaryHoverBkg2Color = buttonSecondaryBkg2Color;
          const buttonSecondaryHoverBkg3Color = buttonSecondaryBkg3Color;
          const buttonSecondaryHoverBkg4Color = buttonSecondaryBkg4Color;

          theme["--btn-secondary-border-radius"] = theme["--btn-primary-border-radius"];
          theme["--btn-secondary-border-color"] = buttonSecondaryBkg1Color;
          theme[
            "--btn-secondary-bkg-image"
          ] = `radial-gradient(50% 50% at left, ${buttonSecondaryBkg3Color}, transparent), radial-gradient(50% 50% at right, ${buttonSecondaryBkg3Color}, transparent), radial-gradient(100% 50% at top, ${buttonSecondaryBkg2Color}, ${buttonSecondaryBkg4Color}, transparent), radial-gradient(100% 50% at bottom, ${buttonSecondaryBkg2Color}, ${buttonSecondaryBkg4Color}, transparent), linear-gradient(${buttonPrimaryBkg1Color}, ${buttonPrimaryBkg1Color})`;
          theme["--btn-secondary-shadow"] = theme["--btn-primary-shadow"];
          theme["--btn-secondary-text-color"] = this.whiteColor;
          theme["--btn-secondary-hover-border-color"] = buttonSecondaryHoverBkg1Color;
          theme[
            "--btn-secondary-hover-bkg-image"
          ] = `radial-gradient(50% 50% at left, ${buttonSecondaryHoverBkg3Color}, transparent), radial-gradient(50% 50% at right, ${buttonSecondaryHoverBkg3Color}, transparent), radial-gradient(100% 50% at top, ${buttonSecondaryHoverBkg2Color}, ${buttonSecondaryHoverBkg4Color}, transparent), radial-gradient(100% 50% at bottom, ${buttonSecondaryHoverBkg2Color}, ${buttonSecondaryHoverBkg4Color}, transparent), linear-gradient(${buttonSecondaryHoverBkg1Color}, ${buttonSecondaryHoverBkg1Color})`;
          theme["--btn-secondary-hover-text-color"] = this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-shadow"]}`;

          return theme;
        },
      },

      Clear: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues };

          const inputBorderColor = mixColor.clone().setAlpha(0.1);
          const inputBkg1Color = mixColorInv.clone().setAlpha(0.25);
          const inputBkg2Color = mixColorInv.clone().setAlpha(0.5);
          const inputShadowColor = shadowColor.clone().setAlpha(0.5);
          const inputHoverBkg1Color = mixColorInv.clone().setAlpha(0.5);
          const inputHoverBkg2Color = mixColorInv.clone().setAlpha(0.75);

          theme["--input-padding"] = "11px";
          theme["--input-border-width"] = "1px";
          theme["--input-border-radius"] = "5px";
          theme["--input-border-color"] = inputBorderColor;
          theme["--input-bkg-image"] = `linear-gradient(${inputBkg1Color}, ${inputBkg2Color})`;
          theme["--input-shadow"] = `0 2px 10px ${inputShadowColor}`;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-bkg-image"] = `linear-gradient(${inputHoverBkg1Color}, ${inputHoverBkg2Color})`;
          theme["--input-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--input-shadow"]}`;
          theme["--input-dropdown-arrow-color"] = acc1Color;
          theme["--input-dropdown-arrow-hover-color"] = acc1Color;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkg1Color = this.whiteColor.clone().setAlpha(0.1);
          const buttonPrimaryBkg2Color = this.blackColor.clone().setAlpha(0.1);
          const buttonPrimaryBkg3Color = this.whiteColor.clone().setAlpha(0.4);
          const buttonPrimaryBkg4Color = acc1Color.clone().setAlpha(0.2);
          const buttonPrimaryShadowColor = shadowColor.clone().setAlpha(1);
          const buttonPrimaryHoverBkg1Color = acc1Color.clone().setAlpha(0.1);
          const buttonPrimaryHoverBkg2Color = acc1Color.clone().setAlpha(0.2);
          const buttonPrimaryHoverBkg3Color = buttonPrimaryBkg3Color;
          const buttonPrimaryHoverBkg4Color = buttonPrimaryBkg4Color;

          theme["--btn-primary-border-color"] = `transparent transparent ${acc1Color} transparent`;
          theme[
            "--btn-primary-bkg-image"
          ] = `radial-gradient(75% 50% at top, ${buttonPrimaryBkg3Color}, transparent), radial-gradient(75% 50% at bottom, ${buttonPrimaryBkg4Color}, transparent), linear-gradient(${buttonPrimaryBkg1Color}, ${buttonPrimaryBkg2Color})`;
          theme["--btn-primary-shadow"] = `0 2px 10px ${buttonPrimaryShadowColor}`;
          theme["--btn-primary-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-primary-hover-bkg-image"
          ] = `radial-gradient(75% 50% at top, ${buttonPrimaryHoverBkg3Color}, transparent), radial-gradient(75% 50% at bottom, ${buttonPrimaryHoverBkg4Color}, transparent), linear-gradient(${buttonPrimaryHoverBkg1Color}, ${buttonPrimaryHoverBkg2Color})`;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-shadow"]}`;

          const buttonSecondaryBkg1Color = buttonPrimaryBkg1Color;
          const buttonSecondaryBkg2Color = buttonPrimaryBkg2Color;
          const buttonSecondaryBkg3Color = buttonPrimaryBkg3Color;
          const buttonSecondaryBkg4Color = acc2Color.clone().setAlpha(0.2);
          const buttonSecondaryHoverBkg1Color = acc2Color.clone().setAlpha(0.1);
          const buttonSecondaryHoverBkg2Color = acc2Color.clone().setAlpha(0.2);
          const buttonSecondaryHoverBkg3Color = buttonSecondaryBkg3Color;
          const buttonSecondaryHoverBkg4Color = buttonSecondaryBkg4Color;

          theme["--btn-secondary-border-color"] = `transparent transparent ${acc2Color} transparent`;
          theme[
            "--btn-secondary-bkg-image"
          ] = `radial-gradient(75% 50% at top, ${buttonSecondaryBkg3Color}, transparent), radial-gradient(75% 50% at bottom, ${buttonSecondaryBkg4Color}, transparent), linear-gradient(${buttonSecondaryBkg1Color}, ${buttonSecondaryBkg2Color})`;
          theme["--btn-secondary-shadow"] = theme["--btn-primary-shadow"];
          theme["--btn-secondary-text-color"] = theme["--btn-primary-text-color"];
          theme[
            "--btn-secondary-hover-bkg-image"
          ] = `radial-gradient(75% 50% at top, ${buttonSecondaryHoverBkg3Color}, transparent), radial-gradient(75% 50% at bottom, ${buttonSecondaryHoverBkg4Color}, transparent), linear-gradient(${buttonSecondaryHoverBkg1Color}, ${buttonSecondaryHoverBkg2Color})`;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-shadow"]}`;

          return theme;
        },
      },

      Plastic: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues, ...borderlessButtonsThemeValues };

          const acc1ColorAt40 = this.tc.mix(bkgColor, acc1Color, 40);
          const acc1ColorAt60 = this.tc.mix(bkgColor, acc1Color, 60);
          const acc1ColorAt80 = this.tc.mix(bkgColor, acc1Color, 80);
          const acc2ColorAt80 = this.tc.mix(bkgColor, acc2Color, 80);

          const inputBkgColor = acc1Color.clone().setAlpha(0.4);
          const inputShadowColor = acc1Color.clone().setAlpha(0.2);
          const inputHoverBkgColor = acc1Color.clone().setAlpha(0.6);
          const inputHoverShadowColor = acc1Color.clone().setAlpha(0.4);

          theme["--input-bkg-color"] = inputBkgColor;
          theme["--input-shadow"] = `0 0 15px ${inputShadowColor}`;
          theme["--input-text-color"] = acc1ColorAt40.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-bkg-color"] = inputHoverBkgColor;
          theme["--input-hover-shadow"] = `0 0 15px ${inputHoverShadowColor}`;
          theme["--input-hover-text-color"] = acc1ColorAt60.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--input-shadow"]}`;
          theme["--input-hoverfocus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--input-hover-shadow"]}`;
          theme["--input-dropdown-arrow-color"] = acc1Color;
          theme["--input-dropdown-arrow-hover-color"] = acc1Color;
          theme["--input-dropdown-option-bkg-color"] = acc1ColorAt60;
          theme["--input-dropdown-option-text-color"] = acc1ColorAt60.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkgColor = acc1Color.clone().setAlpha(0.8);
          const buttonPrimaryShadowColor = acc1Color.clone().setAlpha(0.2);
          const buttonPrimaryHoverBkgColor = acc1Color.clone().setAlpha(1);
          const buttonPrimaryHoverShadowColor = acc1Color.clone().setAlpha(0.4);

          theme["--btn-primary-bkg-color"] = buttonPrimaryBkgColor;
          theme["--btn-primary-shadow"] = `0 0 15px ${buttonPrimaryShadowColor}`;
          theme["--btn-primary-text-color"] = acc1ColorAt80.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-primary-hover-bkg-color"] = buttonPrimaryHoverBkgColor;
          theme["--btn-primary-hover-shadow"] = `0 0 15px ${buttonPrimaryHoverShadowColor}`;
          theme["--btn-primary-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-shadow"]}`;
          theme["--btn-primary-hoverfocus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-hover-shadow"]}`;

          const buttonSecondaryBkgColor = acc2Color.clone().setAlpha(0.8);
          const buttonSecondaryShadowColor = acc2Color.clone().setAlpha(0.2);
          const buttonSecondaryHoverBkgColor = acc2Color.clone().setAlpha(1);
          const buttonSecondaryHoverShadowColor = acc2Color.clone().setAlpha(0.4);

          theme["--btn-secondary-bkg-color"] = buttonSecondaryBkgColor;
          theme["--btn-secondary-shadow"] = `0 0 15px ${buttonSecondaryShadowColor}`;
          theme["--btn-secondary-text-color"] = acc2ColorAt80.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-secondary-hover-bkg-color"] = buttonSecondaryHoverBkgColor;
          theme["--btn-secondary-hover-shadow"] = `0 0 15px ${buttonSecondaryHoverShadowColor}`;
          theme["--btn-secondary-hover-text-color"] = acc2Color.isLight() ? this.blackColor : this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-shadow"]}`;
          theme["--btn-secondary-hoverfocus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-hover-shadow"]}`;

          return theme;
        },
      },

      Hollow: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues };

          const inputBorderColor = mixColor.clone().setAlpha(0.5);
          const inputBkgColor = mixColorInv.clone().setAlpha(0.1);
          const inputHoverBorderColor = mixColor.clone().setAlpha(1);
          const inputHoverBkgColor = mixColorInv.clone().setAlpha(0.25);

          theme["--input-border-color"] = inputBorderColor;
          theme["--input-bkg-color"] = inputBkgColor;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-border-color"] = inputHoverBorderColor;
          theme["--input-hover-bkg-color"] = inputHoverBkgColor;
          theme["--input-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}`;
          theme["--input-dropdown-arrow-color"] = inputBorderColor;
          theme["--input-dropdown-arrow-hover-color"] = inputHoverBorderColor;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBorderColor = this.tc.mix(acc1Color, mixColor, 0);
          const buttonPrimaryBkgColor = acc1Color.clone().setAlpha(0.1);
          const buttonPrimaryTextColor = this.tc.mix(acc1Color, mixColor, 75);
          const buttonPrimaryHoverBorderColor = this.tc.mix(acc1Color, mixColor, 50);
          const buttonPrimaryHoverBkgColor = acc1Color.clone().setAlpha(0.25);
          const buttonPrimaryHoverTextColor = this.tc.mix(acc1Color, mixColor, 100);

          theme["--btn-primary-border-color"] = buttonPrimaryBorderColor;
          theme["--btn-primary-bkg-color"] = buttonPrimaryBkgColor;
          theme["--btn-primary-text-color"] = buttonPrimaryTextColor;
          theme["--btn-primary-hover-border-color"] = buttonPrimaryHoverBorderColor;
          theme["--btn-primary-hover-bkg-color"] = buttonPrimaryHoverBkgColor;
          theme["--btn-primary-hover-text-color"] = buttonPrimaryHoverTextColor;
          theme["--btn-primary-focus-shadow"] = theme["--input-focus-shadow"];

          const buttonSecondaryBorderColor = this.tc.mix(acc2Color, mixColor, 0);
          const buttonSecondaryBkgColor = acc2Color.clone().setAlpha(0.1);
          const buttonSecondaryTextColor = this.tc.mix(acc2Color, mixColor, 75);
          const buttonSecondaryHoverBorderColor = this.tc.mix(acc2Color, mixColor, 50);
          const buttonSecondaryHoverBkgColor = acc2Color.clone().setAlpha(0.25);
          const buttonSecondaryHoverTextColor = this.tc.mix(acc2Color, mixColor, 100);

          theme["--btn-secondary-border-color"] = buttonSecondaryBorderColor;
          theme["--btn-secondary-bkg-color"] = buttonSecondaryBkgColor;
          theme["--btn-secondary-text-color"] = buttonSecondaryTextColor;
          theme["--btn-secondary-hover-border-color"] = buttonSecondaryHoverBorderColor;
          theme["--btn-secondary-hover-bkg-color"] = buttonSecondaryHoverBkgColor;
          theme["--btn-secondary-hover-text-color"] = buttonSecondaryHoverTextColor;
          theme["--btn-secondary-focus-shadow"] = theme["--input-focus-shadow"];

          return theme;
        },
      },

      Neon: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues };

          const inputBorderColor = mixColor.clone().setAlpha(1);
          const inputShadowColor = this.tc.mix(bkgColor, mixColor, 50).setAlpha(0.75);
          const inputHoverBorderColor = mixColor.clone().setAlpha(1);
          const inputHoverShadowColor = this.tc.mix(bkgColor, mixColor, 75).setAlpha(1);

          theme["--input-border-radius"] = "5px";
          theme["--input-border-color"] = inputBorderColor;
          theme["--input-shadow"] = `inset 0 0 15px ${inputShadowColor}, 0 0 15px ${inputShadowColor}`;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-hover-border-color"] = inputHoverBorderColor;
          theme["--input-hover-shadow"] = `inset 0 0 20px ${inputHoverShadowColor}, 0 0 20px ${inputHoverShadowColor}`;
          theme["--input-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--input-focus-shadow"
          ] = `inset 0 0 0 1px ${inputBorderColor}, 0 0 0 1px ${inputBorderColor}, ${theme["--input-hover-shadow"]}`;
          theme[
            "--input-hoverfocus-shadow"
          ] = `inset 0 0 0 1px ${inputHoverBorderColor}, 0 0 0 1px ${inputHoverBorderColor}, ${theme["--input-hover-shadow"]}`;
          theme["--input-dropdown-arrow-color"] = inputBorderColor;
          theme["--input-dropdown-arrow-hover-color"] = inputHoverBorderColor;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = acc1Color.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBorderColor = this.tc.mix(acc1Color, mixColor, 100);
          const buttonPrimaryBkgColor = acc1Color.clone().setAlpha(0.1);
          const buttonPrimaryShadowColor = this.tc.mix(acc1Color, mixColor, 0).setAlpha(0.75);
          const buttonPrimaryHoverBorderColor = this.tc.mix(acc1Color, mixColor, 100);
          const buttonPrimaryHoverBkgColor = acc1Color.clone().setAlpha(0.25);
          const buttonPrimaryHoverShadowColor = this.tc.mix(acc1Color, mixColor, 25).setAlpha(1);

          theme["--btn-primary-border-radius"] = "5px";
          theme["--btn-primary-border-color"] = buttonPrimaryBorderColor;
          theme["--btn-primary-bkg-color"] = buttonPrimaryBkgColor;
          theme[
            "--btn-primary-shadow"
          ] = `inset 0 0 15px ${buttonPrimaryShadowColor}, 0 0 15px ${buttonPrimaryShadowColor}`;
          theme["--btn-primary-text-color"] = buttonPrimaryBorderColor;
          theme["--btn-primary-hover-border-color"] = buttonPrimaryHoverBorderColor;
          theme["--btn-primary-hover-bkg-color"] = buttonPrimaryHoverBkgColor;
          theme[
            "--btn-primary-hover-shadow"
          ] = `inset 0 0 20px ${buttonPrimaryHoverShadowColor}, 0 0 20px ${buttonPrimaryHoverShadowColor}`;
          theme["--btn-primary-hover-text-color"] = buttonPrimaryHoverBorderColor;
          theme[
            "--btn-primary-focus-shadow"
          ] = `inset 0 0 0 1px ${buttonPrimaryBorderColor}, 0 0 0 1px ${buttonPrimaryBorderColor}, ${theme["--btn-primary-hover-shadow"]}`;
          theme[
            "--btn-primary-hoverfocus-shadow"
          ] = `inset 0 0 0 1px ${buttonPrimaryHoverBorderColor}, 0 0 0 1px ${buttonPrimaryHoverBorderColor}, ${theme["--btn-primary-hover-shadow"]}`;

          const buttonSecondaryBorderColor = this.tc.mix(acc2Color, mixColor, 100);
          const buttonSecondaryBkgColor = acc2Color.clone().setAlpha(0.1);
          const buttonSecondaryShadowColor = this.tc.mix(acc2Color, mixColor, 0).setAlpha(0.75);
          const buttonSecondaryHoverBorderColor = this.tc.mix(acc2Color, mixColor, 100);
          const buttonSecondaryHoverBkgColor = acc2Color.clone().setAlpha(0.25);
          const buttonSecondaryHoverShadowColor = this.tc.mix(acc2Color, mixColor, 25).setAlpha(1);

          theme["--btn-secondary-border-radius"] = theme["--btn-primary-border-radius"];
          theme["--btn-secondary-border-color"] = buttonSecondaryBorderColor;
          theme["--btn-secondary-bkg-color"] = buttonSecondaryBkgColor;
          theme[
            "--btn-secondary-shadow"
          ] = `inset 0 0 15px ${buttonSecondaryShadowColor}, 0 0 15px ${buttonSecondaryShadowColor}`;
          theme["--btn-secondary-text-color"] = buttonSecondaryBorderColor;
          theme["--btn-secondary-hover-border-color"] = buttonSecondaryHoverBorderColor;
          theme["--btn-secondary-hover-bkg-color"] = buttonSecondaryHoverBkgColor;
          theme[
            "--btn-secondary-hover-shadow"
          ] = `inset 0 0 20px ${buttonSecondaryHoverShadowColor}, 0 0 20px ${buttonSecondaryHoverShadowColor}`;
          theme["--btn-secondary-hover-text-color"] = buttonSecondaryHoverBorderColor;
          theme[
            "--btn-secondary-focus-shadow"
          ] = `inset 0 0 0 1px ${buttonSecondaryBorderColor}, 0 0 0 1px ${buttonSecondaryBorderColor}, ${theme["--btn-secondary-hover-shadow"]}`;
          theme[
            "--btn-secondary-hoverfocus-shadow"
          ] = `inset 0 0 0 1px ${buttonSecondaryHoverBorderColor}, 0 0 0 1px ${buttonSecondaryHoverBorderColor}, ${theme["--btn-secondary-hover-shadow"]}`;

          return theme;
        },
      },

      SoftCandy: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues, ...borderlessButtonsThemeValues };

          const spin = 45;

          const inputBorder1Color = acc1Color.clone().spin(-spin);
          const inputBorder2Color = acc1Color.clone().spin(0);
          const inputBkg1Color = this.getShiftedLuminosityColor(acc1Color, bkgColor.isLight(), -0.2)
            .spin(-spin)
            .setAlpha(0.25);
          const inputBkg2Color = this.getShiftedLuminosityColor(acc1Color, bkgColor.isLight(), -0.2)
            .spin(0)
            .setAlpha(0.25);
          const inputShadowColor = shadowColor.clone().setAlpha(0.5);
          const inputHoverBorder1Color = this.tc.mix(inputBorder1Color, mixColor, 25);
          const inputHoverBorder2Color = this.tc.mix(inputBorder2Color, mixColor, 25);
          const inputHoverBkg1Color = this.getShiftedLuminosityColor(inputBkg1Color, bkgColor.isLight(), 0.2).setAlpha(
            0.25,
          );
          const inputHoverBkg2Color = this.getShiftedLuminosityColor(inputBkg2Color, bkgColor.isLight(), 0.2).setAlpha(
            0.25,
          );

          theme["--input-border-color"] = inputBorder1Color;
          theme["--input-border-image"] = `linear-gradient(45deg, ${inputBorder1Color}, ${inputBorder2Color}) 2`;
          theme["--input-bkg-image"] = `linear-gradient(45deg, ${inputBkg1Color}, ${inputBkg2Color})`;
          theme["--input-shadow"] = `0px 2px 5px ${inputShadowColor}`;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--input-hover-border-image"
          ] = `linear-gradient(45deg, ${inputHoverBorder1Color}, ${inputHoverBorder2Color}) 2`;
          theme["--input-hover-bkg-image"] = `linear-gradient(45deg, ${inputHoverBkg1Color}, ${inputHoverBkg2Color})`;
          theme["--input-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--input-shadow"]}`;
          theme["--input-dropdown-arrow-color"] = inputBorder2Color;
          theme["--input-dropdown-arrow-hover-color"] = inputHoverBorder2Color;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkg1Color = acc1Color.clone().spin(0);
          const buttonPrimaryBkg2Color = acc1Color.clone().spin(spin);
          const buttonPrimaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );

          theme["--btn-primary-border-radius"] = "5px";
          theme[
            "--btn-primary-bkg-image"
          ] = `linear-gradient(45deg, ${buttonPrimaryBkg1Color}, ${buttonPrimaryBkg2Color})`;
          theme["--btn-primary-shadow"] = theme["--input-shadow"];
          theme["--btn-primary-text-color"] = buttonPrimaryBkg1Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-primary-hover-bkg-image"
          ] = `linear-gradient(45deg, ${buttonPrimaryHoverBkg1Color}, ${buttonPrimaryHoverBkg2Color})`;
          theme["--btn-primary-hover-text-color"] = buttonPrimaryHoverBkg1Color.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-shadow"]}`;

          const buttonSecondaryBkg1Color = acc2Color.clone().spin(0);
          const buttonSecondaryBkg2Color = acc2Color.clone().spin(-spin);
          const buttonSecondaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );

          theme["--btn-secondary-border-radius"] = theme["--btn-primary-border-radius"];
          theme[
            "--btn-secondary-bkg-image"
          ] = `linear-gradient(45deg, ${buttonSecondaryBkg1Color}, ${buttonSecondaryBkg2Color})`;
          theme["--btn-secondary-shadow"] = theme["--input-shadow"];
          theme["--btn-secondary-text-color"] = buttonSecondaryBkg1Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-secondary-hover-bkg-image"
          ] = `linear-gradient(45deg, ${buttonSecondaryHoverBkg1Color}, ${buttonSecondaryHoverBkg2Color})`;
          theme["--btn-secondary-hover-text-color"] = buttonSecondaryHoverBkg1Color.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-shadow"]}`;

          return theme;
        },
      },

      HardCandy: {
        getProcessedTheme: (bkgColor, textColor, acc1Color, acc2Color, mixColor, mixColorInv, shadowColor) => {
          let theme = { ...defaultThemeValues, ...borderlessButtonsThemeValues };

          const inputBorder1Color = acc1Color;
          const inputBorder2Color = this.getShiftedLuminosityColor(inputBorder1Color, bkgColor.isLight(), 0.1);
          const inputBkg1Color = mixColorInv.clone().setAlpha(0.25);
          const inputBkg2Color = mixColorInv.clone().setAlpha(0.5);
          const inputBkg3Color = inputBorder1Color.clone().setAlpha(0.25);
          const inputBkg4Color = inputBorder2Color.clone().setAlpha(0.25);
          const inputShadowColor = shadowColor.clone().setAlpha(1);
          const inputHoverBorder1Color = this.getShiftedLuminosityColor(inputBorder1Color, bkgColor.isLight(), 0.1);
          const inputHoverBorder2Color = this.getShiftedLuminosityColor(inputBorder2Color, bkgColor.isLight(), 0.1);
          const inputHoverBkg1Color = inputBkg1Color;
          const inputHoverBkg2Color = inputBkg2Color;
          const inputHoverBkg3Color = inputHoverBorder1Color.clone().setAlpha(0.25);
          const inputHoverBkg4Color = inputHoverBorder2Color.clone().setAlpha(0.25);

          theme["--input-border-color"] = inputBorder1Color;
          theme[
            "--input-border-image"
          ] = `repeating-linear-gradient(45deg, ${inputBorder1Color} 20px, ${inputBorder2Color} 20px, ${inputBorder2Color} 40px, ${inputBorder1Color} 40px, ${inputBorder1Color} 60px) 2`;
          theme[
            "--input-bkg-image"
          ] = `linear-gradient(to bottom, ${inputBkg3Color}, transparent, ${inputBkg4Color}), repeating-linear-gradient(-45deg, ${inputBkg1Color} 20px, ${inputBkg2Color} 20px, ${inputBkg2Color} 40px, ${inputBkg1Color} 40px, ${inputBkg1Color} 60px)`;
          theme["--input-shadow"] = `0 2px 10px ${inputShadowColor}`;
          theme["--input-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--input-hover-border-image"
          ] = `repeating-linear-gradient(45deg, ${inputHoverBorder1Color} 20px, ${inputHoverBorder2Color} 20px, ${inputHoverBorder2Color} 40px, ${inputHoverBorder1Color} 40px, ${inputHoverBorder1Color} 60px) 2`;
          theme[
            "--input-hover-bkg-image"
          ] = `linear-gradient(to bottom, ${inputHoverBkg3Color}, transparent, ${inputHoverBkg4Color}), repeating-linear-gradient(-45deg, ${inputHoverBkg1Color} 20px, ${inputHoverBkg2Color} 20px, ${inputHoverBkg2Color} 40px, ${inputHoverBkg1Color} 40px, ${inputBkg1Color} 60px)`;
          theme["--input-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;
          theme["--input-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--input-shadow"]}`;
          theme["--input-dropdown-arrow-color"] = inputBorder1Color;
          theme["--input-dropdown-arrow-hover-color"] = inputHoverBorder1Color;
          theme["--input-dropdown-option-bkg-color"] = bkgColor;
          theme["--input-dropdown-option-text-color"] = theme["--input-text-color"];
          theme["--input-dropdown-option-hover-bkg-color"] = acc1Color;
          theme["--input-dropdown-option-hover-text-color"] = bkgColor.isLight() ? this.blackColor : this.whiteColor;

          const buttonPrimaryBkg1Color = acc1Color;
          const buttonPrimaryBkg2Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryBkg3Color = buttonPrimaryBkg1Color.clone().setAlpha(0.66);
          const buttonPrimaryBkg4Color = buttonPrimaryBkg2Color.clone().setAlpha(0.66);
          const buttonPrimaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonPrimaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonPrimaryHoverBkg3Color = buttonPrimaryHoverBkg1Color.clone().setAlpha(0.66);
          const buttonPrimaryHoverBkg4Color = buttonPrimaryHoverBkg2Color.clone().setAlpha(0.66);

          theme["--btn-primary-border-radius"] = "5px";
          theme[
            "--btn-primary-bkg-image"
          ] = `linear-gradient(to bottom, ${buttonPrimaryBkg3Color}, transparent, ${buttonPrimaryBkg4Color}), repeating-linear-gradient(-45deg, ${buttonPrimaryBkg1Color} 20px, ${buttonPrimaryBkg2Color} 20px, ${buttonPrimaryBkg2Color} 40px, ${buttonPrimaryBkg1Color} 40px, ${buttonPrimaryBkg1Color} 60px)`;
          theme["--btn-primary-shadow"] = theme["--input-shadow"];
          theme["--btn-primary-text-color"] = buttonPrimaryBkg1Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-primary-hover-bkg-image"
          ] = `linear-gradient(to bottom, ${buttonPrimaryHoverBkg3Color}, transparent, ${buttonPrimaryHoverBkg4Color}), repeating-linear-gradient(-45deg, ${buttonPrimaryHoverBkg1Color} 20px, ${buttonPrimaryHoverBkg2Color} 20px, ${buttonPrimaryHoverBkg2Color} 40px, ${buttonPrimaryHoverBkg1Color} 40px, ${buttonPrimaryHoverBkg1Color} 60px)`;
          theme["--btn-primary-hover-text-color"] = buttonPrimaryHoverBkg1Color.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-primary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc1Color.complement(),
          )}, ${theme["--btn-primary-shadow"]}`;

          const buttonSecondaryBkg1Color = acc2Color;
          const buttonSecondaryBkg2Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryBkg3Color = buttonSecondaryBkg1Color.clone().setAlpha(0.66);
          const buttonSecondaryBkg4Color = buttonSecondaryBkg2Color.clone().setAlpha(0.66);
          const buttonSecondaryHoverBkg1Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg1Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryHoverBkg2Color = this.getShiftedLuminosityColor(
            buttonSecondaryBkg2Color,
            bkgColor.isLight(),
            0.1,
          );
          const buttonSecondaryHoverBkg3Color = buttonSecondaryHoverBkg1Color.clone().setAlpha(0.66);
          const buttonSecondaryHoverBkg4Color = buttonSecondaryHoverBkg2Color.clone().setAlpha(0.66);

          theme["--btn-secondary-border-radius"] = theme["--btn-primary-border-radius"];
          theme[
            "--btn-secondary-bkg-image"
          ] = `linear-gradient(to bottom, ${buttonSecondaryBkg3Color}, transparent, ${buttonSecondaryBkg4Color}), repeating-linear-gradient(-45deg, ${buttonSecondaryBkg1Color} 20px, ${buttonSecondaryBkg2Color} 20px, ${buttonSecondaryBkg2Color} 40px, ${buttonSecondaryBkg1Color} 40px, ${buttonSecondaryBkg1Color} 60px)`;
          theme["--btn-secondary-shadow"] = theme["--input-shadow"];
          theme["--btn-secondary-text-color"] = buttonSecondaryBkg1Color.isLight() ? this.blackColor : this.whiteColor;
          theme[
            "--btn-secondary-hover-bkg-image"
          ] = `linear-gradient(to bottom, ${buttonSecondaryHoverBkg3Color}, transparent, ${buttonSecondaryHoverBkg4Color}), repeating-linear-gradient(-45deg, ${buttonSecondaryHoverBkg1Color} 20px, ${buttonSecondaryHoverBkg2Color} 20px, ${buttonSecondaryHoverBkg2Color} 40px, ${buttonSecondaryHoverBkg1Color} 40px, ${buttonSecondaryHoverBkg1Color} 60px)`;
          theme["--btn-secondary-hover-text-color"] = buttonSecondaryHoverBkg1Color.isLight()
            ? this.blackColor
            : this.whiteColor;
          theme["--btn-secondary-focus-shadow"] = `${defaultFocusShadowStyle} ${this.getAverageLuminosityColor(
            acc2Color.complement(),
          )}, ${theme["--btn-secondary-shadow"]}`;

          return theme;
        },
      },
    };

    this.paletteGenerationTypes = ["Complement", "Split Complement", "Triad", "Tetrad", "Highest Contrast", "Custom"];

    this.palettes = [];
    this.generatePrimaryPalettes();
  }

  applyTheme = (name, bkgColor, textColor, acc1Color, acc2Color) => {
    const cc = this.getCommonElementColors(bkgColor);
    const outlineColor = this.getAverageLuminosityColor(acc1Color.complement());
    const theme = this.themes[name].getProcessedTheme(
      bkgColor,
      textColor,
      acc1Color,
      acc2Color,
      cc.mixColor,
      cc.mixColorInv,
      cc.shadowColor,
      outlineColor,
    );
    const rootStyle = document.documentElement.style;

    rootStyle.setProperty("--clr-text-primary", cc.mixColor);
    rootStyle.setProperty("--clr-text-secondary", textColor);
    rootStyle.setProperty("--clr-text-placeholder", cc.mixColor.clone().setAlpha(0.5));
    rootStyle.setProperty("--clr-panel-low", cc.panelLowColor);
    rootStyle.setProperty("--clr-panel-low-inv", cc.panelLowColor.complement().setAlpha(0.25));
    rootStyle.setProperty("--clr-panel-mid", cc.panelMidColor);
    rootStyle.setProperty("--clr-panel-mid-inv", cc.panelMidColor.complement().setAlpha(0.25));
    rootStyle.setProperty("--clr-panel-high", cc.panelHighColor);
    rootStyle.setProperty("--clr-panel-high-inv", cc.panelHighColor.complement().setAlpha(0.1));
    rootStyle.setProperty("--clr-link", acc1Color);
    rootStyle.setProperty("--clr-link-hover", this.getShiftedLuminosityColor(acc1Color, bkgColor.isLight(), 0.1));
    rootStyle.setProperty("--clr-outline", outlineColor);
    rootStyle.setProperty("--clr-panel-shadow", cc.shadowColor.clone().setAlpha(0.5));

    emptyThemeKeys.forEach((key) => {
      let value = theme[key];

      if (!value && themeKeyFallbacks[key]) {
        for (let fallbackKeyIdx = 0; fallbackKeyIdx < themeKeyFallbacks[key].length; fallbackKeyIdx++) {
          const fallbackKey = themeKeyFallbacks[key][fallbackKeyIdx];
          const fallbackValue = theme[fallbackKey];

          if (fallbackValue) {
            value = fallbackValue;
            break;
          }
        }
      }

      rootStyle.setProperty(key, value);
    });
  };

  getCommonElementColors = (bkgColor) => {
    const isLight = bkgColor.isLight();

    let cc = {};

    cc.mixColor = isLight ? this.blackColor : this.whiteColor;
    cc.mixColorInv = isLight ? this.whiteColor : this.blackColor;
    cc.panelHighColor = bkgColor;
    cc.panelMidColor = isLight ? bkgColor.clone().darken(5) : bkgColor.clone().lighten(5);
    cc.panelLowColor = isLight ? bkgColor.clone().darken(10) : bkgColor.clone().lighten(10);
    cc.shadowColor = this.getShiftedLuminosityColor(bkgColor, -0.25);

    return cc;
  };

  getShiftedLuminosityColor = (color, isBkgLight, shift) => {
    const colorAsHsl = color.toHsl();

    return this.tc(
      this.tc({
        h: colorAsHsl.h,
        s: colorAsHsl.s,
        l: Math.max(Math.min(colorAsHsl.l + (isBkgLight ? -shift : shift), 1), 0),
      }).toHslString(),
    );
  };

  getAverageLuminosityColor = (color) => {
    const colorAsHsl = color.toHsl();

    return this.tc(this.tc({ h: colorAsHsl.h, s: colorAsHsl.s, l: 0.5 }).toHslString());
  };

  getColor = (input) => {
    return this.tc(input);
  };

  equals = (color1, color2) => {
    return this.tc.equals(color1, color2);
  };

  getThemes = () => {
    return this.themes;
  };

  getThemeStyles = () => {
    return Object.keys(this.themes);
  };

  getPalettes = () => {
    return this.palettes;
  };

  getPaletteGenerationTypes = () => {
    return this.paletteGenerationTypes;
  };

  generatePrimaryPalettes = () => {
    const getSanitizedBkgColor = (color) => {
      if (this.tc.readability(color, this.whiteColor) < 6.9 && this.tc.readability(color, this.blackColor) < 6.9)
        color.setAlpha(0);

      return this.tc(color.toHslString()); // convert original input to be user friendly
    };

    const fillCategory = (hStart, hInterval, sValue) => {
      let category = [];

      for (let h = hStart; h < 360; h += hInterval)
        [0.125, 0.1875, 0.25, 0.3125, 0.6875, 0.75, 0.8125, 0.875].forEach((l) => {
          category.push(getSanitizedBkgColor(this.tc({ h: h, s: sValue, l: l })));
        });

      return category;
    };

    this.palettes.sat10 = {
      name: "10% SATURATION",
      colors: fillCategory(0, 20, 0.1),
    };

    this.palettes.sat20 = {
      name: "20% SATURATION",
      colors: fillCategory(0, 10, 0.2),
    };
  };

  generateSecondaryPalettes = (bkgColor) => {
    const isLight = bkgColor.isLight();
    const start = isLight ? 0.1 : 0.55;
    const end = (isLight ? 0.45 : 0.9) + 0.01;
    const h = bkgColor.toHsl().h;

    const getSanitizedAccColor = (color, minContrast) => {
      if (color.isLight() === isLight || this.tc.readability(color, bkgColor) < minContrast - 0.1) color.setAlpha(0);

      return this.tc(color.toHslString()); // convert original input to be user friendly
    };

    const addToAccColors = (color) => {
      const h = color.toHsl().h;

      let colors = [];
      for (let l = start; l < end; l += 0.05) colors.push(getSanitizedAccColor(this.tc({ h: h, s: 1.0, l: l }), 4.5));

      return colors;
    };

    const flattenArray = (arrays) => {
      let arr = [];

      for (let i = 0; i < arrays.length; i++)
        if (arrays[i]) for (let j = 0; j < arrays[i].length; j++) arr.push(arrays[i][j]);

      return arr;
    };

    const normalizeToBaseLuminosity = (colors) => {
      let a;
      let l;
      let minL = 1;
      let maxL = 0;

      for (let i = 0; i < colors.length; i++) {
        l = colors[i].toHsl().l;
        a = colors[i].getAlpha();

        if (a === 0 && minL > l) minL = l;
        if (a === 0 && maxL < l) maxL = l;
      }

      minL += 0.05;
      maxL -= 0.05;

      for (let i = 0; i < colors.length; i++) {
        l = colors[i].toHsl().l;

        if (isLight && l > minL) colors[i].setAlpha(0);
        else if (!isLight && l < maxL) colors[i].setAlpha(0);
      }

      return colors;
    };

    // .slice(1) to exclude primaryColor

    this.palettes.complement = {
      name: "COMPLEMENT",
      colors: normalizeToBaseLuminosity(flattenArray([bkgColor, bkgColor.complement()].map(addToAccColors))),
    };

    this.palettes.splitcomplement = {
      name: "SPLIT COMPLEMENT",
      colors: normalizeToBaseLuminosity(flattenArray(bkgColor.splitcomplement().slice(1).map(addToAccColors))),
    };

    this.palettes.triad = {
      name: "TRIAD",
      colors: normalizeToBaseLuminosity(flattenArray(bkgColor.triad().slice(1).map(addToAccColors))),
    };

    this.palettes.tetrad = {
      name: "TETRAD",
      colors: normalizeToBaseLuminosity(flattenArray(bkgColor.tetrad().slice(1).map(addToAccColors))),
    };

    this.palettes.analogous = {
      name: "ANALOGOUS",
      colors: normalizeToBaseLuminosity(
        flattenArray(bkgColor.analogous(36, 36).slice(1).concat([bkgColor.complement()]).map(addToAccColors)),
      ),
    };

    let monotone = [];
    for (let s = 0.05; s <= 0.2; s += 0.05)
      for (let l = start; l < end; l += 0.05) monotone.push(getSanitizedAccColor(this.tc({ h: h, s: s, l: l }), 7));

    let grayscale = [];
    for (let v = 0; v <= 256; v += 32)
      if (v !== 128)
        // ignore absolute middle
        grayscale.push(getSanitizedAccColor(this.tc({ r: v, g: v, b: v }), 7));

    this.palettes.monotone = {
      name: "MONOTONE",
      colors: monotone,
    };

    this.palettes.grayscale = {
      name: "GRAYSCALE",
      colors: grayscale,
    };
  };

  getTextColorFromBackgroundColor = (bkgColor) => {
    const colors = [bkgColor.isLight() ? this.blackColor : this.whiteColor].concat(this.palettes.monotone.colors);

    let color = null;

    do {
      color = colors[Math.floor(Math.random() * colors.length)];
    } while (color.getAlpha() !== 1);

    return color;
  };

  getAccentColorsFromBackgroundColor = (paletteGenerationType, bkgColor) => {
    const mixColor = bkgColor.isLight() ? this.blackColor : this.whiteColor;

    const getHueDelta = (h1, h2) => {
      const delta = Math.abs(h1 - h2);

      return delta <= 180 ? delta : 360 - delta;
    };

    const getMostReadableColor = (colors, primaryColor) => {
      const primaryColorAsHsl = primaryColor ? primaryColor.toHsl() : null;

      let color = null;
      let elementContrast = 0;
      let readabilityOnText = 0;

      let newElementContrast = null;
      let newReadabilityOnText = null;

      for (let i = 0; i < colors.length; i++) {
        const newColor = colors[i];
        const newColorAsHsl = newColor.toHsl();

        if (
          newColor.getAlpha() === 1 &&
          (!primaryColor ||
            (primaryColor.isLight() === newColor.isLight() &&
              getHueDelta(primaryColorAsHsl.h, newColorAsHsl.h) >=
                30)) /* &&
              Math.abs(primaryColorAsHsl.l - newColorAsHsl.l) <= 0.15 + 0.01 */
        ) {
          newElementContrast = this.tc.readability(newColor, primaryColor ?? bkgColor);
          newReadabilityOnText = this.tc.readability(newColor, mixColor);

          if (
            readabilityOnText < newReadabilityOnText ||
            (readabilityOnText === newReadabilityOnText && elementContrast < newElementContrast)
          ) {
            color = newColor;
            elementContrast = newElementContrast;
            readabilityOnText = newReadabilityOnText;
          }
        }
      }

      return color ?? (bkgColor.isLight() ? bkgColor.clone().lighten(15) : bkgColor.clone().darken(15));
    };

    let colors = [];

    if (["Highest Contrast", "Custom"].includes(paletteGenerationType)) colors = this.palettes.analogous.colors;
    else if (paletteGenerationType === "Complement") colors = this.palettes.complement.colors;
    else if (paletteGenerationType === "Split Complement") colors = this.palettes.splitcomplement.colors;
    else if (paletteGenerationType === "Triad") colors = this.palettes.triad.colors;
    else if (paletteGenerationType === "Tetrad") colors = this.palettes.tetrad.colors;

    let primaryAccColor = getMostReadableColor(colors);
    let secondaryAccColor = getMostReadableColor(colors, primaryAccColor);

    /*
    const primaryAccColorAsHsl = primaryAccColor.toHsl();
    const secondaryAccColorAsHsl = secondaryAccColor.toHsl();
    const normalizedL = bkgColor.isLight()
      ? Math.min(Math.min(primaryAccColorAsHsl.l, secondaryAccColorAsHsl.l), 0.5)
      : Math.max(Math.max(primaryAccColorAsHsl.l, secondaryAccColorAsHsl.l), 0.5);

    if (normalizedL >= 0.1 && normalizedL <= 0.9) {
      primaryAccColor = this.tc(
        this.tc({
          h: primaryAccColorAsHsl.h,
          s: primaryAccColorAsHsl.s,
          l: normalizedL,
        }).toHslString(),
      );
      secondaryAccColor = this.tc(
        this.tc({
          h: secondaryAccColorAsHsl.h,
          s: secondaryAccColorAsHsl.s,
          l: normalizedL,
        }).toHslString(),
      );
    }
*/
    return {
      primaryAccColor: primaryAccColor,
      secondaryAccColor: secondaryAccColor,
    };
  };

  getRandomBkgColor = () => {
    const colors = [].concat(this.palettes.sat10.colors, this.palettes.sat20.colors);

    let color = null;

    do {
      color = colors[Math.floor(Math.random() * colors.length)];
    } while (color.getAlpha() !== 1); //|| color.isLight());

    return color;
  };

  getRandomThemeStyle = () => {
    const themeStyles = this.getThemeStyles();
    const style = themeStyles[Math.floor(Math.random() * themeStyles.length)];

    return style;
  };

  getRandomPaletteGenerationType = () => {
    const pgt = this.paletteGenerationTypes[Math.floor(Math.random() * (this.paletteGenerationTypes.length - 1))];

    return pgt;
  };
}

export default new ThemeUtils();
